import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import categoryReducer from './reducers/categoryReducer';
import productReducer from './reducers/productReducer';
import authReducer from './reducers/authReducer';
import orderReducer from './reducers/orderReducer';
import customerReducer from './reducers/customerReducer';
import transactionReducer from './reducers/transactionReducer';
import cartReducer from './reducers/cartReducer';
import postalcodeReducer from './reducers/postalcodeReducer';
import publicationReducer from './reducers/publicationReducer';
import bannerReducer from './reducers/bannerReducer';

const rootReducer = combineReducers({
  categories: categoryReducer,
  products: productReducer,
  auth: authReducer,
  orders: orderReducer,
  customers: customerReducer,
  transactions: transactionReducer,
  cart: cartReducer,
  postalcodes: postalcodeReducer,
  publications:publicationReducer, 
  banners:bannerReducer, 
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
